import { Dealness, RecommendationV2 } from "@b2bportal/air-shopping-api";

/**
 * A `fair` forecast with a `Buy` recommendation is rendered as neutral copy
 * instead of the buy indication. Shared so diagnostics cannot drift from the
 * bar that actually renders it.
 */
export function shouldForceNeutralPrediction(
  dealness?: Dealness | null,
  recommendation?: RecommendationV2 | null
): boolean {
  return dealness === Dealness.fair && recommendation === RecommendationV2.Buy;
}
